import CircularIndeterminate from '../components/CircularLoad';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

export default function BrandFilter ({options, selectedBrands, loading, handleCheckboxChange }){
    return (
        <div id="brand-filter">
            <h3 style={{ color: 'green', marginLeft: '2.5%', marginTop: '2.5%', fontWeight: '300' }}>
                Brands
            </h3>
            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <CircularIndeterminate display={loading} />
            </div>
            <FormGroup style={{ margin: '0px' }}>
                {options.map(option => (
                    <FormControlLabel
                        key={option.value}
                        color='success'
                        style={{ margin: '0px' }}
                        control={
                            <Checkbox
                                checked={selectedBrands.includes(option.value)}
                                onChange={handleCheckboxChange}
                                value={option.value}
                            />
                        }
                        label={option.label}
                    />
                ))}
            </FormGroup>
        </div>
    )
}